/* vs-home.js — quick add + Buy 1 Get 1 bag bar for homepage product sections. */
let Events = null;
try { Events = await import('@shopify/events'); } catch (e) { Events = null; }

const cfgEl = document.querySelector('[data-vsh-bag]');
let cfg = {};
try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}

let bar = document.querySelector('.vsh-bag');
if (!bar) {
  bar = document.createElement('div');
  bar.className = 'vsh-bag';
  bar.setAttribute('aria-live', 'polite');
  bar.innerHTML = '<div class="vsh-bag__in"><div class="vsh-bag__msg"></div><a class="vsh-bag__btn" href="/cart">View bag</a></div>';
  document.body.appendChild(bar);
}
const msg = bar.querySelector('.vsh-bag__msg');
const btn = bar.querySelector('.vsh-bag__btn');

function money(cents) {
  const n = cents / 100;
  return String(cfg.money || 'Rs. {{amount}}')
    .replace(/\{\{\s*amount[^}]*\}\}/, n.toLocaleString('en-IN', { maximumFractionDigits: n % 1 ? 2 : 0 }))
    .replace(/<[^>]+>/g, '');
}

function paint(count, total) {
  bar.classList.toggle('show', count > 0);
  if (count <= 0) return;
  if (count % 2 === 1) {
    msg.innerHTML = cfg.odd || "<b>Add 1 more – it's free.</b> Buy 1 Get 1 applies automatically.";
    btn.textContent = 'View bag'; btn.href = '/cart';
  } else {
    msg.innerHTML = String(cfg.even || '<b>[count] pieces for [total]</b> – free shipping & COD').replace('[count]', count).replace('[total]', money(total));
    btn.textContent = 'Checkout'; btn.href = '/checkout';
  }
}
if (cfg.count > 0) paint(cfg.count, cfg.total);

document.addEventListener('click', async (e) => {
  const b = e.target.closest('.vsh [data-add]');
  if (!b) return;
  const id = b.dataset.add;
  const label = b.dataset.label || 'Add to Bag';
  b.classList.add('is-loading');
  const fd = new FormData();
  fd.append('id', id); fd.append('quantity', '1');
  const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  if (ids.length) fd.append('sections', ids.join(','));
  fd.append('sections_url', location.pathname);
  let deferred = null;
  try {
    if (Events && Events.CartLinesUpdateEvent) {
      deferred = Events.CartLinesUpdateEvent.createPromise();
      b.dispatchEvent(new Events.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise }));
    }
  } catch (err) { deferred = null; }
  try {
    const data = await (await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })).json();
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    if (data.status) throw new Error(data.description || 'Could not add');
    try { if (deferred) deferred.resolve({ cart: Events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'vs-home', itemCount: 1, sections: data.sections, didError: false } }); } catch (err) {}
    b.classList.remove('is-loading'); b.classList.add('is-added'); b.textContent = 'Added ✓';
    setTimeout(() => { b.classList.remove('is-added'); b.textContent = label; }, 1600);
    paint(cart.item_count, cart.total_price);
  } catch (err) {
    try { if (deferred) deferred.reject(err); } catch (e2) {}
    b.classList.remove('is-loading'); b.textContent = 'Try again';
    setTimeout(() => { b.textContent = label; }, 2000);
  }
});
